import type { AuthenticationStrategy } from "@/vendors/authentication/authentication-strategy.types"
import { fetchUserFromAuth0 } from "@/vendors/authentication/providers/auth0/actions/fetch-authorization-from-auth0"

const auth0Configuration: AuthenticationStrategy.Configuration = {
  hasDoubleOptIn: false,
  hasInternalProfilePages: false,
  isPasswordRequired: false,
}

const createLogout: AuthenticationStrategy.Urls["createLogout"] = ({
  redirect,
}) => {
  return `/auth/logout?url=${encodeURIComponent(redirect)}`
}

export const auth0Strategy: AuthenticationStrategy = {
  configuration: auth0Configuration,
  fetchUser: fetchUserFromAuth0,
  type: "auth0",
  urls: {
    createLogin: ({ redirect }) => {
      return `/auth/login?returnTo=${encodeURIComponent(redirect)}`
    },
    createLogout,
    createLogoutToLogin: ({ redirect }) => {
      const loginUrl = `/auth/login?returnTo=${encodeURIComponent(redirect)}`

      return createLogout({ redirect: loginUrl })
    },
    createProfile: ({ redirect }) => {
      return `/auth/login?screen_hint=signup&returnTo=${encodeURIComponent(redirect)}`
    },
    createTrial: ({ absoluteDomainName, redirect }) => {
      const trialCreationUrl = `${absoluteDomainName}/profile/add/trial?redirectUrl=${encodeURIComponent(redirect)}&type=create-trial`

      return `/auth/login?screen_hint=signup&returnTo=${encodeURIComponent(trialCreationUrl)}`
    },
    manageAccount: (siteModel) => siteModel.urls.myAccount,
  },
}
